// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.bs.js");
var MM_proof_tree_dto = require("./MM_proof_tree_dto.bs.js");

function extractVarToRecIdxMapping(args, frame) {
  var varToRecIdxMapping = new Array(frame.numOfVars);
  var locks = Belt_Array.make(frame.numOfVars, false);
  if (args.length !== frame.numOfArgs) {
    return {
            TAG: /* Error */1,
            _0: "extractVarToRecIdxMapping: args.Js_array2.length != frame.numOfArgs"
          };
  }
  var err = {
    contents: undefined
  };
  frame.hyps.forEach(function (hyp, i) {
        if (!(Belt_Option.isNone(err.contents) && hyp.typ === /* F */0)) {
          return ;
        }
        var v = Caml_array.get(hyp.expr, 1);
        if (Caml_array.get(locks, v)) {
          err.contents = {
            TAG: /* Error */1,
            _0: "extractVarToRecIdxMapping: locks[v]"
          };
          return ;
        } else {
          Caml_array.set(locks, v, true);
          return Caml_array.set(varToRecIdxMapping, v, Caml_array.get(args, i));
        }
      });
  var err$1 = err.contents;
  if (err$1 !== undefined) {
    return err$1;
  } else if (locks.some(function (lock) {
          return !lock;
        })) {
    return {
            TAG: /* Error */1,
            _0: "extractVarToRecIdxMapping: locks->Js_array2.some(lock => !lock)"
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: varToRecIdxMapping
          };
  }
}

function getHeight(ch) {
  if (ch.TAG === /* Subtree */0) {
    return ch._0.height;
  } else {
    return 0;
  }
}

function getMaxHeight(children) {
  return children.reduce((function (max, ch) {
                return Math.max(max, getHeight(ch));
              }), 0);
}

function buildSyntaxTreeInner(idSeq, ctx, tbl, parent, r) {
  var match = r.proof;
  if (match.TAG === /* Hypothesis */0) {
    var label = match.label;
    var maxI = r.expr.length - 1 | 0;
    var this_id = Curry._1(idSeq, undefined);
    var this_children = new Array(maxI);
    var $$this = {
      id: this_id,
      parent: parent,
      label: label,
      children: this_children,
      height: 0
    };
    for(var i = 1; i <= maxI; ++i){
      Caml_array.set(this_children, i - 1 | 0, {
            TAG: /* Symbol */1,
            id: Curry._1(idSeq, undefined),
            parent: $$this,
            sym: MM_context.ctxIntToSymExn(ctx, Caml_array.get(r.expr, i)),
            color: undefined,
            isVar: Caml_array.get(r.expr, i) >= 0
          });
    }
    return {
            TAG: /* Ok */0,
            _0: {
              id: this_id,
              parent: parent,
              label: label,
              children: this_children,
              height: getMaxHeight(this_children) + 1 | 0
            }
          };
  }
  var label$1 = match.label;
  var frame = MM_context.getFrame(ctx, label$1);
  if (frame === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Cannot find a frame by label '" + label$1 + "' in buildSyntaxTreeInner."
          };
  }
  var msg = extractVarToRecIdxMapping(match.args, frame);
  if (msg.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: msg._0
          };
  }
  var varToRecIdxMapping = msg._0;
  var this_id$1 = Curry._1(idSeq, undefined);
  var this_children$1 = new Array(frame.asrt.length - 1 | 0);
  var $$this$1 = {
    id: this_id$1,
    parent: parent,
    label: label$1,
    children: this_children$1,
    height: 0
  };
  var err = {
    contents: undefined
  };
  frame.asrt.forEach(function (s, i) {
        if (!(i > 0 && Belt_Option.isNone(err.contents))) {
          return ;
        }
        if (s < 0) {
          return Caml_array.set(this_children$1, i - 1 | 0, {
                      TAG: /* Symbol */1,
                      id: Curry._1(idSeq, undefined),
                      parent: $$this$1,
                      sym: MM_context.ctxIntToSymExn(ctx, s),
                      color: undefined,
                      isVar: false
                    });
        }
        var msg = buildSyntaxTreeInner(idSeq, ctx, tbl, $$this$1, Caml_array.get(tbl, Caml_array.get(varToRecIdxMapping, s)));
        if (msg.TAG === /* Ok */0) {
          return Caml_array.set(this_children$1, i - 1 | 0, {
                      TAG: /* Subtree */0,
                      _0: msg._0
                    });
        } else {
          err.contents = {
            TAG: /* Error */1,
            _0: msg._0
          };
          return ;
        }
      });
  var err$1 = err.contents;
  if (err$1 !== undefined) {
    return err$1;
  } else {
    return {
            TAG: /* Ok */0,
            _0: {
              id: this_id$1,
              parent: parent,
              label: label$1,
              children: this_children$1,
              height: getMaxHeight(this_children$1) + 1 | 0
            }
          };
  }
}

function buildSyntaxTree(ctx, tbl, targetIdx) {
  var nextId = {
    contents: 0
  };
  var idSeq = function (param) {
    nextId.contents = nextId.contents + 1 | 0;
    return nextId.contents - 1 | 0;
  };
  return buildSyntaxTreeInner(idSeq, ctx, tbl, undefined, Caml_array.get(tbl, targetIdx));
}

function syntaxTreeToSymbols(node) {
  return Belt_Array.concatMany(node.children.map(function (childNode) {
                  if (childNode.TAG === /* Subtree */0) {
                    return syntaxTreeToSymbols(childNode._0);
                  } else {
                    return [childNode.sym];
                  }
                }));
}

function syntaxTreeIsEmpty(node) {
  return node.children.length === 0;
}

function getNodeById(tree, childId) {
  return Expln_utils_data.traverseTree(undefined, {
                TAG: /* Subtree */0,
                _0: tree
              }, (function (param, node) {
                  if (node.TAG === /* Subtree */0) {
                    return node._0.children;
                  }
                  
                }), undefined, (function (param, node) {
                  var id;
                  id = node.TAG === /* Subtree */0 ? node._0.id : node.id;
                  if (id === childId) {
                    return node;
                  }
                  
                }), undefined, undefined)[1];
}

function buildSyntaxProofTableFromProofTreeDto(ctx, proofTreeDto, typeStmt) {
  var proofNode = proofTreeDto.nodes.find(function (node) {
        return MM_context.exprEq(node.expr, typeStmt);
      });
  if (proofNode !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: MM_proof_tree_dto.createProofTable(proofTreeDto, proofNode, undefined, undefined, undefined)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "buildSyntaxProofTableFromProofTreeDto: could not find a proof for: " + MM_context.ctxIntsToStrExn(ctx, typeStmt) + ""
          };
  }
}

function buildSyntaxTreeFromProofTreeDto(ctx, proofTreeDto, typeStmt) {
  var msg = buildSyntaxProofTableFromProofTreeDto(ctx, proofTreeDto, typeStmt);
  if (msg.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: msg._0
          };
  }
  var proofTable = msg._0;
  return buildSyntaxTree(ctx, proofTable, proofTable.length - 1 | 0);
}

exports.buildSyntaxTree = buildSyntaxTree;
exports.buildSyntaxProofTableFromProofTreeDto = buildSyntaxProofTableFromProofTreeDto;
exports.buildSyntaxTreeFromProofTreeDto = buildSyntaxTreeFromProofTreeDto;
exports.syntaxTreeToSymbols = syntaxTreeToSymbols;
exports.syntaxTreeIsEmpty = syntaxTreeIsEmpty;
exports.getNodeById = getNodeById;
/* MM_context Not a pure module */
